export const hrDashboardTabsIds = ['0', '1', '2', '3', '4', '5', '6', '7'] as const;
